import { buildModelManager } from "../builder.js";
const DefaultConversationSelection = {
  __typename: true,
  id: true,
  attributedUserId: true,
  contactId: true,
  createdAt: true,
  crispConversationId: true,
  customerId: true,
  easiwareConversationId: true,
  easiwareConversationSecret: true,
  gorgiasCustomerId: true,
  isArchived: true,
  isEasiwareConversationActive: true,
  isGaiaActivated: true,
  isOpened: true,
  isWaitingForWhatsappMessage: true,
  isZendeskTicketSolved: true,
  isZendeskTicketWaiting: true,
  lastAutomaticReplyAt: true,
  lastAwayMessageAt: true,
  lastContext: true,
  lastGaiaAiConfigurationId: true,
  lastGaiaFlowNodeId: true,
  lastGaiaMessageAt: true,
  lastGorgiasTicketAt: true,
  lastGorgiasTicketId: true,
  lastHubspotNoteAt: true,
  lastInboundMessageAt: true,
  lastMessageAt: true,
  lastMessagePreview: true,
  lastReadAt: true,
  lastUnscriptedMessageAt: true,
  nodeAfterWhatsappMessageId: true,
  updatedAt: true,
  zendeskTicketId: true,
  zendeskTicketSolvedAt: true,
  zendeskUserId: true
};
const modelApiIdentifier = "conversation";
const pluralModelApiIdentifier = "conversations";
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultConversationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultConversationSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultConversationSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultConversationSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultConversationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultConversationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultConversationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByContact",
    findByField: "contactId",
    findByVariableName: "contactId",
    modelApiIdentifier,
    defaultSelection: DefaultConversationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByContact",
    findByField: "contactId",
    findByVariableName: "contactId",
    modelApiIdentifier,
    defaultSelection: DefaultConversationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByCustomer",
    findByField: "customerId",
    findByVariableName: "customerId",
    modelApiIdentifier,
    defaultSelection: DefaultConversationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByCustomer",
    findByField: "customerId",
    findByVariableName: "customerId",
    modelApiIdentifier,
    defaultSelection: DefaultConversationSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createConversation",
    operationReturnType: "CreateConversation",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      conversation: { required: false, type: "CreateConversationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultConversationSelection
  },
  {
    type: "action",
    operationName: "bulkCreateConversations",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateConversationsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultConversationSelection
  },
  {
    type: "action",
    operationName: "updateConversation",
    operationReturnType: "UpdateConversation",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      conversation: { required: false, type: "UpdateConversationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultConversationSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateConversations",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateConversationsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultConversationSelection
  },
  {
    type: "action",
    operationName: "deleteConversation",
    operationReturnType: "DeleteConversation",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteConversations",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "cleanWaitingNodeConversation",
    operationReturnType: "CleanWaitingNodeConversation",
    functionName: "cleanWaitingNode",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      conversation: { required: false, type: "CleanWaitingNodeConversationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultConversationSelection
  },
  {
    type: "action",
    operationName: "bulkCleanWaitingNodeConversations",
    functionName: "bulkCleanWaitingNode",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "cleanWaitingNode",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCleanWaitingNodeConversationsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultConversationSelection
  },
  {
    type: "action",
    operationName: "upsertConversation",
    operationReturnType: "UpsertConversation",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      conversation: { required: false, type: "UpsertConversationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateConversationResult": { hasReturnType: false },
      "... on UpdateConversationResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultConversationSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertConversations",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertConversationsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultConversationSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "conversationGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ConversationManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultConversationSelection,
  operations
);
export {
  ConversationManager,
  DefaultConversationSelection
};
//# sourceMappingURL=Conversation.js.map
